import React, { useEffect } from "react";
import { Controller, useWatch } from "react-hook-form";

import {
  CCheckbox,
  CNumberInput,
  CSelect,
} from "src/common/components/controls";

export const Row = ({ materialsOptions, control, rowIndex, setValue }) => {
  //#region Event
  const handleSelectMaterial =
    (onChangeCallback, index) => (value, selectedOption) => {
      onChangeCallback(value);
      setValue(`materials.${index}.warePrice`, selectedOption?.warePrice);
      setValue(`materials.${index}.wareUnit`, selectedOption?.wareUnit);
    };
  //#endregion

  //#region Render
  return (
    <tr>
      <td>
        <Controller
          control={control}
          name={`materials.${rowIndex}.checked`}
          render={({ field }) => <CCheckbox {...field} />}
        />
      </td>
      <td>
        <Controller
          control={control}
          name={`materials.${rowIndex}.code`}
          render={({ field }) => (
            <CSelect
              disabled
              options={materialsOptions}
              {...field}
              display="code"
            />
          )}
        />
      </td>
      <td>
        <Controller
          control={control}
          name={`materials.${rowIndex}.code`}
          render={({ field: { onChange, ..._field } }) => (
            <CSelect
              className="text-left"
              options={materialsOptions}
              {..._field}
              onChange={handleSelectMaterial(onChange, rowIndex)}
              select="value"
            />
          )}
        />
      </td>
      <td>
        <Controller
          control={control}
          name={`materials.${rowIndex}.code`}
          render={({ field }) => (
            <CSelect
              options={materialsOptions}
              {...field}
              disabled
              display="wareUnit"
            />
          )}
        />
      </td>
      <td>
        <Controller
          control={control}
          name={`materials.${rowIndex}.wareQ`}
          render={({ field }) => <CNumberInput {...field} />}
        />
      </td>
      <td>
        <Controller
          control={control}
          name={`materials.${rowIndex}.code`}
          render={({ field }) => (
            <CSelect
              className="text-right"
              disabled
              options={materialsOptions}
              {...field}
              display="warePrice"
            />
          )}
        />
      </td>
      <td>
        <MaterialTotalInput
          control={control}
          setValue={setValue}
          index={rowIndex}
        />
      </td>
    </tr>
  );
  //#endregion
};

const MaterialTotalInput = ({ control, setValue, index, label }) => {
  const wareQ = useWatch({ control, name: `materials.${index}.wareQ` });
  const warePrice = useWatch({ control, name: `materials.${index}.warePrice` });

  useEffect(() => {
    const total = wareQ * warePrice;
    setValue(`materials.${index}.total`, total);
  }, [wareQ, warePrice, index]);

  return (
    <Controller
      control={control}
      name={`materials.${index}.total`}
      render={({ field }) => (
        <CNumberInput
          label={label || undefined}
          disabled
          {...field}
          className={!label && "text-right"}
        />
      )}
    />
  );
};
